export const ASEAN_DESCRIPTION =
  "Your go-to portal for up-to-date business guides, information, and resources for all businesses and investors with an interest in ASEAN.";
export const SGSME_DESCRIPTION =
  "A news-driven repository of information and knowledge for Singapore's SMEs";
export const GLOBAL_DESCRIPTION =
  "Everything you need to know about Global Enterprise and the people behind them.";
